import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LineFloatingButton from '../../components/feature/LineFloatingButton';
import PriceHeroSection from './components/PriceHeroSection';
import PriceTableSection from './components/PriceTableSection';
import PriceCTASection from './components/PriceCTASection';
import SeoHead from '../../components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const priceJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  url: `${SITE_URL}/price`,
  name: '東京シニア婚活 料金プラン | 縁結び 和はは',
  description: '東京のシニア婚活相談所「縁結び和はは」の料金プラン一覧。50代・60代・70代向けのシニア婚活を明確な料金体系でご提供。東京の婚活相談所の入会費・月会費・成婚料など詳しくご案内。',
  about: {
    '@type': 'PriceSpecification',
    description: 'シニア婚活相談所料金プラン',
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'ホーム', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: '料金プラン', item: `${SITE_URL}/price` },
    ],
  },
};

export default function PricePage() {
  return (
    <>
      <SeoHead
        title="東京シニア婚活の料金プラン | 縁結び 和はは"
        description="東京のシニア婚活相談所「縁結び和はは」の料金プラン。婚活東京シニア専門で50代・60代・70代の婚活をサポートする明確な料金体系。東京シニア婚活の入会費・月会費・成婚料など詳しくご案内。"
        keywords="東京 シニア 婚活, 婚活相談所 料金 東京, シニア婚活費用, 50代婚活料金, 60代婚活料金, 婚活入会費東京"
        path="/price"
        jsonLd={priceJsonLd}
      />
      <Navbar />
      <main>
        <PriceHeroSection />
        <PriceTableSection />
        <PriceCTASection />
      </main>
      <Footer />
      <LineFloatingButton />
    </>
  );
}
